// import 'bootstrap';
// import 'mdbootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'mdbootstrap/css/mdb.min.css';
global.jQuery = require('jquery');
global.$ = global.jQuery;

import * as core from '../libs/tech.core'
import * as lazyLoad from '../libs/tech.lazy-load'
import * as legal from '../libs/tech.legal'
import * as scrollup from '../libs/tech.scrollup'
import * as phone from '../libs/tech.phone'

$(function () {
    lazyLoad.initLazyLoad('.anim-trigger');
    lazyLoad.initLazyLoad('.lazyBackground');
})
//more imports here

export { core, lazyLoad, legal, scrollup, phone}